import ReturnHeaderMeta from "@dana/Components/StandardReturns/ReturnHeaderMeta";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import TextField from "@insite/mobius/TextField";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { FC } from "react";
import { css } from "styled-components";

// --- Props Interface ---
interface StepInternalRefOnlyProps {
    internalRefNumber: string;
    onChangeInternalRef: (v: string) => void;
}

// --- Styles Interfaces and Objects ---
export interface StepInternalRefOnlyStyles {
    sectionTitle?: TypographyPresentationProps;
}

export const StepInternalRefOnlyStyles: StepInternalRefOnlyStyles = {
    sectionTitle: {
        css: css`
            margin-bottom: 16px;
        `,
    },
};

const styles = StepInternalRefOnlyStyles;

// --- Component Definition ---
const StepInternalRefOnly: FC<StepInternalRefOnlyProps> = ({ internalRefNumber, onChangeInternalRef }) => {
    return (
        <StyledWrapper className="internal-ref">
            <ReturnHeaderMeta />
            <StyledWrapper className="input-group">
                <TextField
                    label={translate("Incluce your internal return reference number (optional)")}
                    value={internalRefNumber}
                    onChange={e => onChangeInternalRef(e.target.value)}
                    placeholder={translate("Enter Reference Number")}
                />
            </StyledWrapper>
        </StyledWrapper>
    );
};

export default StepInternalRefOnly;
